import type { PullIn, PullLineIn } from "./api";

export type PullDraftLine = {
  sku: string;
  qty: string;
  located: string;
  avgUnitValue: string | null;
  inboundPerUnit: string | null;
};

/** Located quantity is the ceiling; blank quantity lines are not sent. */
export function pullLineProblem(line: PullDraftLine, factoryName: string): string | null {
  if (line.qty.trim() === "") return null;
  const qty = Number(line.qty);
  if (!Number.isFinite(qty) || qty <= 0) return "Enter a quantity above zero.";
  if (qty > Number(line.located)) return `Only ${line.located} at ${factoryName}.`;
  return null;
}

/** Preview only; the engine response remains the source of truth. */
export function pullLineValue(line: PullDraftLine): { unit: number; inbound: number; total: number } | null {
  if (line.avgUnitValue === null || line.qty.trim() === "") return null;
  const unit = Number(line.avgUnitValue);
  const inbound = Number(line.inboundPerUnit ?? "0");
  const qty = Number(line.qty);
  return { unit, inbound, total: (unit + inbound) * qty };
}

/** IDs are supplied by preview state and therefore survive a manual retry. */
export function buildPull(
  runKey: string,
  entity: "LTD" | "OU",
  factory: string,
  occurredAt: string,
  lines: PullDraftLine[],
  ids: string[],
): PullIn {
  const sent: PullLineIn[] = [];
  lines.forEach((line, index) => {
    if (line.qty.trim() === "") return;
    sent.push({ sku: line.sku, qty: line.qty.trim(), pull_event_id: ids[index] });
  });
  return { run_key: runKey.trim(), entity, factory, occurred_at: occurredAt, lines: sent };
}
